import {Injectable} from '@angular/core';
import {Observable, take} from 'rxjs';
import {ActivatedRouteSnapshot} from '@angular/router';
import {map} from 'rxjs/operators';
import {BaseApiEndpointService} from '../base-endpoint/base-endpoint.service';
import {ListItem} from '../../types/list-item.type';
import {ServiceProviderHub, SingleResponse} from '@generated-backend-types';
import EventInquiry = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Eventmanagement.Event.Inquiry.EventInquiry;
import EventInquiryStateData = ServiceProviderHub.App.Data.ServiceProviderHub.ServiceProviderInquiries.ServiceProviderInquiryStateData;

@Injectable()
export class EventInquiriesService extends BaseApiEndpointService<EventInquiry> {

  public forEvent(e: {id: string} | string): void {
    const id = typeof e === 'string' ? e : e.id;
    this.endpoint = `/events/${id}/inquiries`;
  }

  public override resolve(route: ActivatedRouteSnapshot): Observable<EventInquiry> {
    const eventId = route.parent?.parent?.params['id'] ?? route.parent?.params['id'];
    if (!eventId) {
      throw new Error('EventInquiriesService.resolve: missing :id on parent route');
    }
    this.forEvent(eventId);
    return this.get(route.params['inquiryId']).pipe(map(r => r.data));
  }

  public changeState(inquiryId: string, data: EventInquiryStateData): Observable<SingleResponse<EventInquiry>> {
    return this.http
      .post<SingleResponse<EventInquiry>>(`${this.endpoint}/${inquiryId}/state`, data)
      .pipe(take(1));
  }

  public modelToMultiSelectItem(m: EventInquiry): ListItem & {model: EventInquiry} {
    return {
      id: m.id,
      text: m.ext_inquiry_id,
      isDisabled: false,
      model: m,
    };
  }
}
